import { generatePath } from 'react-router-dom'
import { ITaskProjectFavorite } from '@common/interfaces/taskProject'
import { ROUTES } from '../constants/routes'

export const MAX_VISIBLE_FAVORITE_TABS = 5

export const favoriteProjectRoute = (projectId: string): string =>
  generatePath(ROUTES.TASK_PROJECT_PAGE, { id: projectId })

export const splitFavoriteTabs = (favorites: ITaskProjectFavorite[]) => ({
  visible: favorites.slice(0, MAX_VISIBLE_FAVORITE_TABS),
  overflow: favorites.slice(MAX_VISIBLE_FAVORITE_TABS),
})

// The overflow dropdown resolves a pick by label (see `handleClickMenuItem` in
// Common/Tabs), and project names aren't unique — so a repeat gets a counter or
// both entries would open the first one.
export const disambiguateLabels = (favorites: ITaskProjectFavorite[]): string[] => {
  const seen = new Map<string, number>()
  return favorites.map(({ name }) => {
    const count = (seen.get(name) ?? 0) + 1
    seen.set(name, count)
    return count === 1 ? name : `${name} (${count})`
  })
}

const isFavoriteProjectRoute = (pathname: string, favorites: ITaskProjectFavorite[]): boolean =>
  favorites.some(({ id }) => favoriteProjectRoute(id) === pathname)

/**
 * Whether a pathname is a Tasks tab the sidebar should return to: My Tasks or a
 * favorited project. All Projects and Custom Fields are passed through, not worked
 * out of, so they never displace it. Shared by the recording and resolving side.
 */
export const isRememberedTaskRoute = (
  pathname: string,
  favorites: ITaskProjectFavorite[],
): boolean => pathname === ROUTES.MY_TASKS || isFavoriteProjectRoute(pathname, favorites)
